@if (isAccountAdmin$ | async) {
<h1 class="mat-headline-6">{{ "ONSIP_I18N.PLAN_DETAILS" | translate }}</h1>
<onsip-account-information></onsip-account-information>
}

<div class="title-header onsip-grid-placement">
  <h1 class="mat-headline-6">Overview</h1>
  <div class="date-range-selection">
    <div class="date-range">
      <span class="date-start">{{ (dateStart | date : "longDate") + " -" }}</span>
      <span class="date-end">&nbsp;{{ dateEnd | date : "longDate" }}</span>
    </div>
    <mat-form-field class="interval-dropdown" onsip-form-field-flush-outline appearance="outline">
      <mat-select [formControl]="intervalForm">
        @for (option of intervalOptions; track option) {
        <mat-option [value]="option">
          {{ option.label }}
        </mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>
</div>
<mat-card class="inbound-calling-activity">
  <onsip-pbx-inbound-calling-activity
    [dateStart]="dateStart"
    [dateEnd]="dateEnd"
  ></onsip-pbx-inbound-calling-activity>
</mat-card>
<mat-card class="outbound-calling-activity">
  <onsip-pbx-outbound-calling-activity
    [dateStart]="dateStart"
    [dateEnd]="dateEnd"
  ></onsip-pbx-outbound-calling-activity>
</mat-card>
<mat-card class="calling-trends">
  <onsip-pbx-inbound-outbound-calling-trends
    [dateStart]="dateStart"
    [dateEnd]="dateEnd"
  ></onsip-pbx-inbound-outbound-calling-trends>
</mat-card>
